import { AttributeValue } from "@msdyn365-commerce/retail-proxy";

export const getAttributeByName = (attributeValues: AttributeValue[] | undefined, keyValue: string): AttributeValue | undefined => {
    return attributeValues && attributeValues.find(currAttribute => currAttribute.Name && currAttribute.Name.toLowerCase().trim() === keyValue.toLowerCase().trim());
};
export const getAttributeValueByNameUnbxd = (list: any[] | undefined, keyValue: string | undefined): string | undefined => {
    return keyValue && list && list[keyValue];
};
export const getAttributeArrayValueByNameUnbxd = (list: any[] | undefined, keyValue: string | undefined): string[] | undefined => {
    return keyValue && list && list[keyValue];
};
export const getAttributeTextValue = (attribute: AttributeValue | undefined): string | undefined => {
    return attribute && attribute.TextValue;
};
export const getunbxdAttributeNameByCRTName = (crtName: string | undefined, mapList: any): string | undefined => {
    return mapList && Array.isArray(mapList) && mapList?.find((attr: any) => crtName && attr?.CRTName.toLowerCase().trim() === crtName.toLowerCase().trim())?.UnbxdName;
};